var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 8.00004C1.33337 9.76815 2.03575 11.4638 3.286 12.7141C4.53624 13.9643 6.23193 14.6667 8.00004 14.6667C9.76815 14.6667 11.4638 13.9643 12.7141 12.7141C13.9643 11.4638 14.6667 9.76815 14.6667 8.00004C14.6667 6.23193 13.9643 4.53624 12.7141 3.286C11.4638 2.03575 9.76815 1.33337 8.00004 1.33337C6.23193 1.33337 4.53624 2.03575 3.286 3.286C2.03575 4.53624 1.33337 6.23193 1.33337 8.00004V8.00004Z",
    stroke: "#373737",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.00009V5.61914",
    stroke: "#373737",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L10.9759 10.9765",
    stroke: "#373737",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.8292aeb3b46e7a9b8adcd868adba397f.svg";
export { ForwardRef as ReactComponent };